import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Pagination, TagsListEntity } from '@core/entities';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { GetUserId } from '@core/utils';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  userId = GetUserId();
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = environment.apiUrl;

  get(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<TagsListEntity> {
    return this._http.get<any>(`${this._apiUrl}/tags/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }

  find(pagination?: Partial<Pagination>, queryParams?: FilterQuery): Observable<any> {
    const url = pagination ? `${this._apiUrl}/tags?pageSize=${pagination.pageSize}&page=${pagination.page}` : `${this._apiUrl}/tags`;
    return this._http.get<any>(url, { params: queryParams }).pipe(
      map((res: any) => {
        return res.result;
      }),
    );
  }

  create(data: any): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/createTag`, data);
  }

  update(id: number, data: any): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/updateTag/${id}`, data);
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/deleteTag/${id}`);
  }
}
